import React from 'react'
import { Popover } from '@headlessui/react'
import { Link } from 'react-router-dom'
import { navigation } from '../../../Data/NavbarData'
import Blogcart from './Blogcart'
import ScrollToTop from '../../ScrollToTop'
function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}
const Blogs = () => {
    const [blogfilterlist, setBlogfilterlist] = React.useState(navigation.blogs)
    const handleblogfilter = (e) => {
        console.log(e);
        const newblog = navigation.blogs.filter(pd => pd.categories.includes(e))
        setBlogfilterlist(newblog)
    }
    return (
        <>
            <ScrollToTop />
            <div className="mb-10">
                <div className="w-full h-40 flex justify-center items-center" style={{ background: '#f6f6f6' }}>
                    <h1 className="text-4xl text-blk-txt">Blog Section</h1>
                </div>
                <div className="h-8 flex items-center justify-center my-8 px-4">

                    <Popover.Group className="">
                        <div className="h-full flex items-center justify-center flex-wrap space-x-8">
                            {navigation.categories.map((category) => (
                                <Popover key={category.name} className="flex">
                                    {({ open }) => (
                                        <>
                                            <div className="relative flex py-1" onClick={() => handleblogfilter(category.id)}>
                                                <Popover.Button

                                                    className={classNames(
                                                        open
                                                            ? 'border-primary-txt pb-1 text-primary-txt font-light'
                                                            : 'border-transparent text-gray-700 font-light hover:text-gray-800',
                                                        'relative z-10 flex items-center transition-colors font-light ease-out duration-200 text-sm  border-b-2 -mb-px pt-px'
                                                    )}
                                                >
                                                    {category.name}
                                                </Popover.Button>
                                            </div>


                                        </>
                                    )}
                                </Popover>
                            ))}
                        </div>
                    </Popover.Group>
                </div>
                <div className="grid grid-cols-1 gap-y-5 md:grid-cols-3 md:gap-4 lg:grid-cols-4 lg:gap-6 px-4">
                    {
                        blogfilterlist.map((blog, index) => <Blogcart key={index} blog={blog} />)
                    }

                </div>
            </div>

        </>
    )
}

export default Blogs
